export function SwanLogo({ size = 44, className = "" }) {
  return (
    <img
      src="/swan-logo.png"
      alt="JTS Swanson"
      width={size}
      height={size}
      className={`rounded-full object-cover ring-1 ring-[#C9A84A]/40 ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

export function Wordmark({ size = 44, showTagline = false, center = false }) {
  return (
    <div className={`flex items-center gap-3 ${center ? "flex-col text-center" : ""}`}>
      <SwanLogo size={size} />
      <div>
        <div className="font-serif font-bold text-white leading-none" style={{ fontSize: size * 0.5 }}>
          JTS Swanson
        </div>
        {showTagline && (
          <div className="gold-text font-serif italic text-xs mt-1">
            Removing the friction from your finances
          </div>
        )}
      </div>
    </div>
  );
}

export function TaglineDivider() {
  return (
    <div className="flex items-center gap-3 w-full max-w-sm mx-auto my-4">
      <div className="gold-divider flex-1" />
      <span className="gold-text font-serif italic text-sm whitespace-nowrap">
        Removing the friction from your finances
      </span>
      <div className="gold-divider flex-1" />
    </div>
  );
}
